/**
 * @desc 当前售后服务信息是否是最后一个
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** id */
  id: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<boolean>>(
    `/storeapi/inner/after/sale/service/isLast`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<boolean>;
export default req;
